import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M2.667 5.332h10.667v8.667a.667.667 0 0 1-.667.666H3.334A.667.667 0 0 1 2.667 14zm1.334 1.333v6.667h8V6.665zM6 8h1.333v4H6.001zm2.666 0H10v4H8.667zm-4-4.667V1.999c0-.368.299-.667.667-.667h5.333c.369 0 .667.299.667.667v1.333h3.333v1.333H1.334V3.332zM6 2.666v.667h4v-.667z"
    }, null, -1)
  ]))]))
}
export default { render: render }